import { schema } from 'normalizr';

const agreementWithdrawSchema = new schema.Entity('agreementWithdraw');

export default agreementWithdrawSchema;
